/**
 * Widens the `xstyle` type to bypass the component's constrained property allowlist.
 *
 * Use this when you have a legitimate need that the component's `xstyle` tier doesn't
 * support — either a CSS property not in the allowlist, or a hard-coded value for a
 * property that normally requires a themed token.
 *
 * Prefer the typed `xstyle` path whenever possible. `unsafeXStyle` calls are
 * intentionally grepable so that clusters of the same property on the same component
 * become a signal to consider promoting features into the Design System.
 *
 * @example Passing a CSS property not in the component's allowlist
 * ```tsx
 * const styles = stylex.create({
 *   draggable: { cursor: 'grab' },
 * });
 *
 * <Card xstyle={unsafeXStyle(styles.draggable)}>Drag me</Card>
 * ```
 *
 * @example Passing a hard-coded value for a property that normally requires a themed token
 * ```tsx
 * const styles = stylex.create({
 *   stripped: { backgroundColor: 'transparent', borderStyle: 'none' },
 * });
 *
 * <Input xstyle={unsafeXStyle(styles.stripped)} />
 * ```
 */
export function unsafeXStyle(styles) {
  return styles;
}